import type { DeliveryDiscountType } from '../enums/DeliveryDiscountType'
import type { DayOfWeek } from '@/shared/enums/DayOfWeekEnum'
import type { BranchMiniEntity } from '@/features/branch/domain/entities/BranchMiniEntity'
import type { DiscountTypeForDeliveryDiscount } from '../enums/DiscountType'

export class CreateUpdateDeliveryDiscountEntity {
  name?: string | null //
  type?: DeliveryDiscountType //
  segments?: Array<DeliveryDiscountSegmentEntity> | null //
  priority?: number | null //
  startDate?: string | null //
  endDate?: string | null //
  isActive?: boolean ///
  ignoreDaysCheck?: boolean //
  branches?: Array<BranchMiniEntity> | null
  days?: Array<DeliveryDiscountDayEntity> | null
}
export class DeliveryDiscountSegmentEntity {
  from?: number
  to?: number
  discountValue?: number
  discountType?: DiscountTypeForDeliveryDiscount
  serviceRatio?: number | null
  branchRatio?: number | null
  limitedBranchShareAmount?: number | null
  shareType?: string
}
export class DeliveryDiscountDayEntity {
  dayOfWeek?: DayOfWeek
  periods?: Array<DeliveryDiscountPeriodEntity> | null
}

export class DeliveryDiscountPeriodEntity {
  startTime?: string
  startTimeDayOfWeek?: DayOfWeek
  endTime?: string
  endTimeDayOfWeek?: DayOfWeek
}
